import { render, staticRenderFns } from "./FindFriends.vue?vue&type=template&id=9cbf728e&"
import script from "./FindFriends.vue?vue&type=script&lang=js&"
export * from "./FindFriends.vue?vue&type=script&lang=js&"
import style0 from "./FindFriends.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports